import type { DeckFormat } from "@punkrecords/types";

export interface FormatRules {
  format: DeckFormat;
  mainDeckSize: number;
  maxCopiesPerCard: number;
  enforceLeaderColorMatch: boolean;
}

export const CONSTRUCTED_RULES: FormatRules = {
  format: "constructed",
  mainDeckSize: 50,
  maxCopiesPerCard: 4,
  enforceLeaderColorMatch: true,
};

export const SEALED_RULES: FormatRules = {
  format: "sealed",
  mainDeckSize: 40,
  maxCopiesPerCard: -1,
  enforceLeaderColorMatch: false,
};

export function getRulesForDeck(deck: { format?: DeckFormat }): FormatRules {
  return deck.format === "sealed" ? SEALED_RULES : CONSTRUCTED_RULES;
}

export const SEALED_ELIGIBLE_PREFIXES = ["OP", "EB"];
